import React from "react";
import { Container, Row, Col } from "reactstrap";
import Breadcrumb from "../../Components/Common/BreadCrumb";
import OrdersTable from "./Table";
import AssignedRadialBar from "./Assignment";
import CompletionBar from "./CompletionBar";
import Overlay from "../../Components/Common/Overlay";

const Compliance = () => {
  document.title = "Dashboard | Risknox";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
           <Overlay type="coming-soon" height={1000}>
            <Breadcrumb title="Controls" pageTitle="Compliance" />
          <Row>
            <Col lg={6}>
              <AssignedRadialBar dataColors='["--vz-primary"]' />
            </Col>

            <Col xl={6}>
              <CompletionBar />
            </Col>

          </Row>
         
          <OrdersTable />
          </Overlay>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Compliance;
